<app-admin-toast></app-admin-toast>
<div class="padding-component">
    <app-header [title]="'Auditados'"></app-header>

    <mat-tab-group >
        <mat-tab label="Auditados"><app-clients></app-clients></mat-tab>
        <mat-tab label="Locaciones"><app-locations ></app-locations></mat-tab>
    </mat-tab-group>
</div>